import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {Carousel,Button,CarouselItem,Image} from 'element-ui';

Vue.config.productionTip = false

Vue.use(Carousel);
Vue.use(CarouselItem)
Vue.use(Image);

new Vue({
  el: '#app',
  router,
  render: h => h(App),
  components: {
    App
  },
  template: '<App/>'
})
